import { render } from "./productCart.vue?vue&type=template&id=74437bc1"
import script from "./productCart.vue?vue&type=script&lang=js"
export * from "./productCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__